import {useState, useEffect, useRef} from "react";
import './index.css';
import {useTranslation} from 'react-i18next';
import advantages from './data';
import advantages_en from './data_en';
import advantages_vi from './data_vi';

function AdvantageDisplay() {
    const {t, i18n} = useTranslation();
    const [advantagesData, setAdvantagesData] = useState([]);
    const [visibleItems, setVisibleItems] = useState(new Set());
    const itemRefs = useRef([]);

    useEffect(() => {
        const loadAdvantages = () => {
            const lang = i18n.language;
            let data;
            if (lang.startsWith('en')) {
                data = advantages_en;
            } else if (lang.startsWith('vi')) {
                data = advantages_vi;
            } else {
                data = advantages;
            }
            setAdvantagesData(data);
        };
        loadAdvantages();
        i18n.on('languageChanged', loadAdvantages);
        return () => {
            i18n.off('languageChanged', loadAdvantages);
        };
    }, [i18n]);

    useEffect(() => {
        const observers = [];
        itemRefs.current.forEach((el, i) => {
            if (!el) return;
            const observer = new IntersectionObserver(
                ([entry]) => {
                    if (entry.isIntersecting) {
                        setTimeout(() => {
                            setVisibleItems(prev => new Set([...prev, i]));
                        }, i * 80);
                        observer.disconnect();
                    }
                },
                { threshold: 0.15 }
            );
            observer.observe(el);
            observers.push(observer);
        });
        return () => observers.forEach(o => o.disconnect());
    }, [advantagesData]);

    return (
        <div className="adv-section">
            <div className="adv-section-inner">
                <div className="adv-header">
                    <div className="adv-header-tag">{t('xiaomai_advantage')}</div>
                    <h2 className="adv-header-title">{t('9advantageOfXiaomai')}</h2>
                    <div className="adv-header-line" />
                </div>

                <div className="adv-grid">
                    {advantagesData.map((adv, i) => (
                        <div
                            key={adv.id}
                            ref={el => itemRefs.current[i] = el}
                            className={`adv-item ${visibleItems.has(i) ? 'visible' : ''}`}
                        >
                            <div className="adv-num">{String(adv.id).padStart(2, '0')}</div>
                            <div className="adv-content">
                                <h3 className="adv-title">{adv.title}</h3>
                                <p className="adv-desc">{adv.description}</p>
                            </div>
                            {adv.image && (
                                <div className="adv-img-wrap">
                                    <img src={adv.image} alt={adv.title} className="adv-img" />
                                    <div className="adv-img-overlay" />
                                </div>
                            )}
                            <div className="adv-sweep" />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default AdvantageDisplay;
